import './style';
import './mobile';
import App from './components/app';

import { ApolloClient } from 'apollo-client';
import { createHttpLink } from 'apollo-link-http';
import { setContext } from 'apollo-link-context';
import { InMemoryCache } from 'apollo-cache-inmemory';
import { ApolloProvider } from 'react-apollo';

const httpLink = createHttpLink({ uri: 'https://buy.just.is/api/graphql' })

const middlewareLink = setContext(() => ({
  headers: {
    'X-Shopify-Storefront-Access-Token': 'c1a09671130c2bad617bb1708ebcd139'
  }
}))

const client = new ApolloClient({
  link: middlewareLink.concat(httpLink),
  cache: new InMemoryCache(),
})

export default () => (
  <ApolloProvider client={client}>
    <App client={client} />
  </ApolloProvider>
)


// This removes a service worker that may have been installed by mistake during
// previous deployments.
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.ready.then(function(registration) {
    registration.unregister()
  })
}



// WEBPACK FOOTER //
// ./index.js